import React, { FC } from 'react';
import isEmpty from 'lodash/isEmpty';
import { Link, Typography } from '@material-ui/core';
import { Row } from 'components/UI/Row';
import { useTranslation } from 'react-i18next';

interface Resource {
  name: string;
  url: string;
  translatable: boolean;
}

interface Group {
  section: string;
  resources: Resource[];
}

interface RelatedResourcesProps {
  relatedResources: Group[];
}

const RelatedResources: FC<RelatedResourcesProps> = ({ relatedResources }) => {
  const { t } = useTranslation();
  return !isEmpty(relatedResources) ? (
    <>
      {relatedResources.map((group, key) => (
        <React.Fragment key={key}>
          <Row margin="32px 16px 0 16px">
            <Typography variant="h6">{t(`preview.${group.section}`)}</Typography>
          </Row>
          {group.resources.map((link, key) => (
            <React.Fragment key={key}>
              <Row margin="8px 16px 0 16px">
                <Link target="_blank" href={link.url}>
                  {link.translatable ? t(`preview.${link.name}`) : link.name}
                </Link>
              </Row>
            </React.Fragment>
          ))}
        </React.Fragment>
      ))}
    </>
  ) : null;
};

export { RelatedResources };
